import React from "react"
import ResourceRequestRecord from "../molecules/ResourceRequestRecord"
import { ResourceBookingSchema } from "../data/types";
import { capitalizeString } from "../utils/helpers";
import Pagination from "./Pagination";
import SortableHeader, { SortDirection } from "./SortableHeader";

export type ResourceRequestSortField =
  | 'user_full_name'
  | 'username'
  | 'resource_name'
  | 'start_time'
  | 'created'
  | 'status';

// export type { SortDirection };

type ResourceRequestListProps = {
  resourceType: string
  requests: ResourceBookingSchema[],
  isRequests?: boolean
  currentPage: number
  currentRequests: ResourceBookingSchema[]
  totalPages: number
  itemsPerPage: number
  handlePageChange: (page: number) => void
  sortField: ResourceRequestSortField
  sortDirection: SortDirection
  onSort: (field: ResourceRequestSortField) => void
  hasSearchFilter?: boolean
}

const ResourceRequestList: React.FC<ResourceRequestListProps> = ({
  resourceType,
  requests,
  isRequests,
  currentPage,
  currentRequests,
  totalPages,
  itemsPerPage,
  handlePageChange,
  sortField,
  sortDirection,
  onSort,
  hasSearchFilter,
}) => {

  var dateFieldName = ""
  switch(resourceType){
    case 'training':
      dateFieldName = "Date"
      break
    case 'expert':
      dateFieldName = "Session Date"
      break
    case 'kitchen':
      dateFieldName =  "Booking Time"
      break
  }

  const emptyMessage = hasSearchFilter ? 'No matching requests' : 'No Requests'

  return (
    <div>
      <table className="min-w-full divide-y divide-gray-200 font-open-sans">
        <thead className="bg-gray-50">
          <tr>
            <SortableHeader
              label="Full Name"
              field="user_full_name"
              sortField={sortField}
              sortDirection={sortDirection}
              onSort={onSort}
            />

            <SortableHeader
              label="Email"
              field="username"
              sortField={sortField}
              sortDirection={sortDirection}
              onSort={onSort}
            />

            <SortableHeader
              label={capitalizeString(resourceType)}
              field="resource_name"
              sortField={sortField}
              sortDirection={sortDirection}
              onSort={onSort}
            />

            {dateFieldName && (
              <SortableHeader
                label={dateFieldName}
                field="start_time"
                sortField={sortField}
                sortDirection={sortDirection}
                onSort={onSort}
              />
            )}

            <SortableHeader
              label="Submitted"
              field="created"
              sortField={sortField}
              sortDirection={sortDirection}
              onSort={onSort}
            />

            <SortableHeader
              label="Status"
              field="status"
              sortField={sortField}
              sortDirection={sortDirection}
              onSort={onSort}
            />

            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Actions
            </th>
          </tr>
        </thead>

        <tbody className="bg-white divide-y divide-gray-200">
          {
            currentRequests?.length ? currentRequests.map((request: ResourceBookingSchema, i: number) => (
              <ResourceRequestRecord
                key={request.id ?? i}
                allRequests={requests}
                request={request}
                isRequests={isRequests}
              />
            )) : (
              <tr>
                <td colSpan={7} className="px-6 py-4 text-sm text-gray-500 text-center">
                  {emptyMessage}
                </td>
              </tr>
            )
          }
        </tbody>
      </table>
      {requests.length > itemsPerPage && (
        <div className="mt-4 mb-4">
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
            totalItems={requests.length}
            itemsPerPage={itemsPerPage}
          />
        </div>
      )}
    </div>
  );
};

export default ResourceRequestList;
